/* chikchak — theme interactions */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- scroll reveal ---- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---- mobile nav toggle ---- */
  var toggle = document.querySelector('.nav-toggle');
  var links = document.querySelector('.nav-links');
  if (toggle && links) {
    toggle.addEventListener('click', function () {
      links.classList.toggle('open');
    });
  }

  /* ---- collection filter chips ---- */
  var chips = document.querySelectorAll('.chip');
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var cat = chip.getAttribute('data-cat');
      chips.forEach(function (c) { c.classList.remove('on'); });
      chip.classList.add('on');
      document.querySelectorAll('.shop-grid-wrap .card').forEach(function (card) {
        var cardCat = card.getAttribute('data-cat') || '';
        if (cat === 'all' || cardCat.indexOf(cat) !== -1) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });

  /* ---- product gallery thumbs ---- */
  var thumbs = document.querySelectorAll('.product-thumb');
  var mainImg = document.querySelector('.product-main-img img');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-full');
      if (mainImg && src) {
        mainImg.src = src;
        thumbs.forEach(function (t) { t.classList.remove('on'); });
        thumb.classList.add('on');
      }
    });
  });

});
